import axios from 'axios';
import { get } from 'lodash';
import store from './store';
import router from './router';

const backendUrl = process.env.VUE_APP_BACKEND_BASE_URL;
axios.defaults.baseURL = backendUrl;

axios.interceptors.request.use(function(request) {
  if (request.baseURL.includes(backendUrl) && store.getters['auth/isLoggedIn']) {
    const token = store.getters['auth/getAuthToken'];
    request.headers['Authorization'] = 'Bearer ' + token;
  }
  return request;
});

axios.interceptors.response.use(
  response => response,
  error => {
    if (
      get(error, 'response.status') === 401 &&
      get(error, 'response.config.baseURL', '').includes(backendUrl)
    ) {
      store.dispatch('auth/logout');
      if (router.currentRoute && router.currentRoute.name !== 'login') {
        router.push({ name: 'login' });
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
